/** @module csi/monitor/NodeMonitor */
define([
    "dojo/_base/declare",
    "csi/_base/EventTarget",
    "csi/comm"
], function (declare, EventTarget, comm) {

    /**
     * A base class for node monitors
     */
    const NodeMonitor = declare(EventTarget, {
        url: null,

        constructor: function (url) {
            this.url = url;
        },

        /**
         * Pull the node from the server explicitly
         * without waiting for the server-side message
         *
         * @return Deferred for this request
         */
        refreshNode: function () {
            //console.log("refreshNode is called");
            return comm.getNodeRequest(this.url).go({
                load: (response) => this._onRefreshNode(response)
            });
        },

        /**
         * Set the polling interval for the node request
         * if NodeMonitor supports it.
         * Do nothing by default.
         *
         * @param {Number} milliseconds - refresh interval in milliseconds
         */
        setRefreshInterval: function (milliseconds) { },

        /**
         * Callback for 'refreshNode' function.
         * Dispatches NODE_CHANGED event to listeners
         *
         * @param {JsonResponse} response
         */
        _onRefreshNode: function (response) {
            // notify listeners if received node; it is possible that node is new and is just being created, in which
            // case the request may not return a node
            var node = response.getResultNode();
            //console.log("_onRefreshNode is called. node=", node);
            if (node) {
                this._dispatchNodeChangedEvent(node);
            }
        },

        /**
         * Dispatches NODE_CHANGED event to listeners
         * @param {Node} node
         */
        _dispatchNodeChangedEvent: function (node) {
            //console.log("Dispatching NODE_CHANGED event for", node);
            this.dispatchEvent({
                type: NodeMonitor.NODE_CHANGED,
                node: node
            });
        },

        /**
         * Dispatches NODE_DELETED event to listeners
         * @param {CNL} cnl
         */
        _dispatchNodeDeletedEvent: function (cnl) {
            //console.log("Dispatching NODE_DELETED event for", cnl);
            this.dispatchEvent({
                type: NodeMonitor.NODE_DELETED,
                cnl: cnl
            });
        }
    });

    // predefined events
    NodeMonitor.NODE_CHANGED = "NodeChanged";
    NodeMonitor.NODE_DELETED = "NodeDeleted";

    /**
     * Default factory function
     * @param {string} url
     * @return {NodeMonitor}
     */
    NodeMonitor.createMonitorForUrl = (url) => null;

    return NodeMonitor;
});